import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

export function queryOwnerWechat(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.listAppUserBindingOwners',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId(),
        appTypeCd: '10010'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取业主微信信息失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
